import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { random } from 'lodash-es';

@Component({
  selector: 'app-refresh-token-modal',
  templateUrl: './refresh-token-modal.component.html',
  styleUrls: ['./refresh-token-modal.component.scss'],
  standalone: false,
})
export class RefreshTokenModalComponent implements OnInit, OnDestroy {
  public readonly dialogRef = inject<MatDialogRef<RefreshTokenModalComponent>>(MatDialogRef);

  public showUnlocked = false;
  public progressStep = 1;

  public interval: any;

  ngOnInit(): void {
    this.progressStep = 1;
    let min = 1;
    let max = 10;
    this.interval = window.setInterval(() => {
      if (this.progressStep >= 80) {
        min = 1;
        max = 7;
      }

      const nextVal = this.progressStep + random(min, max);
      this.progressStep = nextVal > 99 ? 99 : nextVal;

      if (this.progressStep >= 99) {
        window.clearInterval(this.interval);
        // this.dialogRef.close();
        return;
      }
    }, 150);
  }

  ngOnDestroy(): void {
    window.clearInterval(this.interval);
  }
}
